import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var InsertMath = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.103 34.774c.4.4.4 1.099 0 1.499-.4.4-1.098.4-1.498 0l-5.793-5.993-5.793 5.993c-.4.4-1.099.4-1.498 0-.4-.4-.4-1.1 0-1.499l5.793-5.992-5.793-5.993c-.4-.4-.4-1.099 0-1.498.4-.4 1.099-.4 1.498 0l5.793 5.992 5.793-5.992c.4-.4 1.099-.4 1.498 0 .4.399.4 1.098 0 1.498L35.31 28.78l5.793 5.993Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.43 5.909c.2-.4.5-.6 1-.6H43a1 1 0 0 1 .999 1 1 1 0 0 1-.999.998H20.13L7.243 38.07c-.2.4-.6.7-.999.6-.4 0-.799-.3-.899-.8L.053 19.693c-.2-.599.2-1.098.699-1.298.599-.2 1.098.2 1.298.7l4.395 15.48L18.43 5.91Z"
  }));
});
InsertMath.displayName = 'InsertMath';
InsertMath.defaultProps = {
  'aria-label': 'InsertMath'
};
export default InsertMath;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Editor/InsertMath.js
// module id = 3550
// module chunks = 11